var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Item',{attrs:{"name":_vm.$t('messenger.archived_chats'),"text":_vm.archivedChatsPreview,"avatar":require('@/assets/archive-icon.svg'),"hide-info":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }